var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessenger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1446_3073)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.51934 0.78125C4.59641 0.78125 0.78125 4.37914 0.78125 9.23879C0.78125 11.7806 1.82574 13.9771 3.5259 15.4945C3.81945 15.7585 3.75898 15.9114 3.80891 17.5416C3.81284 17.6558 3.84465 17.7673 3.90156 17.8664C3.95847 17.9655 4.03876 18.0491 4.13543 18.11C4.23209 18.1709 4.34219 18.2073 4.45612 18.2159C4.57005 18.2245 4.68436 18.2051 4.78906 18.1593C6.64918 17.3402 6.67309 17.2755 6.98844 17.3613C12.3775 18.8445 18.2188 15.3957 18.2188 9.23879C18.2188 4.37914 14.4426 0.78125 9.51934 0.78125ZM14.7661 7.28973L12.1996 11.3527C12.1027 11.5055 11.9753 11.6366 11.8254 11.7379C11.6754 11.8391 11.5062 11.9083 11.3282 11.9411C11.1503 11.9738 10.9675 11.9695 10.7913 11.9283C10.6151 11.8872 10.4494 11.8101 10.3044 11.7018L8.2625 10.1736C8.17122 10.1051 8.0602 10.0681 7.94609 10.0681C7.83199 10.0681 7.72097 10.1051 7.62969 10.1736L4.87449 12.2633C4.50676 12.5421 4.02512 12.1016 4.27297 11.7124L6.83938 7.64938C6.93625 7.49655 7.06366 7.3654 7.21361 7.26413C7.36356 7.16286 7.53282 7.09367 7.71077 7.06089C7.88872 7.02812 8.07152 7.03246 8.24771 7.07365C8.4239 7.11485 8.58968 7.192 8.73465 7.30027L10.7758 8.82817C10.8671 8.89663 10.9781 8.93363 11.0922 8.93363C11.2063 8.93363 11.3174 8.89663 11.4086 8.82817L14.1652 6.74059C14.5323 6.46004 15.0139 6.9002 14.7661 7.28973Z",
    fill: "#2B2B2B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1446_3073"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessenger);
export default __webpack_public_path__ + "static/media/Messenger.eb4de70f5905ac73d79d09fb8eee677f.svg";
export { ForwardRef as ReactComponent };